module.exports = __webpack_public_path__ + "static/media/authentication-corner.ccf7bed3.png";